import { Component } from "react";
import { Sidebar as ProSideBar, Menu, MenuItem, SubMenu, } from "react-pro-sidebar";
import { Divider } from "@mui/material";
import ChevronRight from '@mui/icons-material/ChevronRight';
import ExpandMore from "@mui/icons-material/ExpandMore";
import LogoutIcon from '@mui/icons-material/Logout';
import UpdatePasswordIcon from '@mui/icons-material/Lock';
import EditProfileIcon from '@mui/icons-material/Edit';
import { NavLink } from "react-router";
import UserThumbnail from "./UserThumbnail";
import logo from '../../../media/logo.png';
import { logout } from "../../../utils";
import SettingsIcon from '@mui/icons-material/Settings';
import { connect } from "react-redux";
import { hasIntersection } from "../../../../../shared/utils";
import { USER_ROLE } from "../../../../../shared/constants";


class _Sidebar extends Component {

   renderIcon(Icon) {
      return <Icon
         className="text-xl"
      />
   }

   renderCaption(caption)  {
      return <span className="text-[13px]">
         {caption}
      </span>
   }

   renderExpandIcon({ open }) {
      const Icon = open ? ExpandMore : ChevronRight;
      return <Icon className="text-gray-400" />
   }

   getFullPath(path) {
      let fullPath = '/dashboard' + path;

      if (fullPath.lastIndexOf('/') === fullPath.length - 1)
         fullPath = fullPath.substring(0, fullPath.length - 1);

      return fullPath;
   }

   closeSidebar() {
      if (typeof this.props.onClose === 'function')
         this.props.onClose();
   }

   renderMenuItems(items) {

      return items.map((item, index) => {

         if (item.children) {
            return <SubMenu 
               key={index}
               label={this.renderCaption(item.caption)}
               icon={this.renderIcon(item.icon)}
            >
               {this.renderMenuItems(item.children)}
            </SubMenu>
         } else {

            const { path, icon, onClick: onClickItem } = item;
            
            const onClick = () => {
               if (typeof onClickItem === 'function') {
                  onClickItem();
               }

               this.closeSidebar();
            }

            return <MenuItem 
               key={index} 
               onClick={onClick}
               icon={this.renderIcon(icon)}
               component={ path ? <NavLink to={this.getFullPath(path)} /> : undefined}
               active={path.includes("users")}
            >
               {this.renderCaption(item.caption)}
            </MenuItem>
         }
      });
   }

   render() {

      const accountOperations = [
         ...(
            hasIntersection(this.props.roles, [ USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN , USER_ROLE.FINANCE_MANAGER ]) ? [
               {
                  icon: SettingsIcon,
                  caption: 'System Settings',
                  onClick: this.props.openSystemSettings,
               }
            ] : []
         ),
         {
            icon: EditProfileIcon,
            caption: 'Edit Profile',
            onClick: this.props.openProfileEditor,
         },
         {
            icon: UpdatePasswordIcon,
            caption: 'Update password',
            onClick: this.props.openPasswordEditor,
         }
      ]

      return <div
         className="h-screen w-full grid grid-rows-[auto,1fr,auto] border-r bg-white"
      >
         <div>
            <div className="py-4 flex justify-center">
               <img src={logo} alt="logo" className="w-[150px]" />
            </div>

            <Divider />
         </div>
         <div className="overflow-hidden">
            <ProSideBar backgroundColor="transparent" className="h-full w-full border-r-[0px]">
               <Menu
                  menuItemStyles={{
                     button: {
                        '&:hover': {
                           backgroundColor: '#FB923C',
                           color: 'white',
                        },
                        [`&.active`]: {
                           backgroundColor: '#EA5806',
                           color: 'white',
                        },
                     }
                  }}
                  renderExpandIcon={this.renderExpandIcon}
                  className="text-gray-500"
               >
                  {this.renderMenuItems(this.props.items)}
               </Menu>

            </ProSideBar>
         </div>
         <div className="w-full py-6 [&>*]:px-6 z-30 border-t">
            <div className="md:hidden">
               <UserThumbnail />
               <Divider className="mt-4 my-2" />
            </div>
            {
               accountOperations.map(
                  item => <div
                     className="py-2 cursor-pointer hover:bg-gray-200 grid grid-cols-[auto,1fr] gap-4"
                     onClick={() => {
                        item.onClick();
                        this.closeSidebar();
                     }}
                  >
                     <div className="flex items-center">
                        <item.icon className="text-gray-400" /> 
                     </div>
                     <div className="flex items-center text-gray-600 text-sm">
                        {item.caption}
                     </div>
                  </div>
               )
            }

            <Divider className="my-4" />

            <div className="py-2 cursor-pointer hover:bg-gray-200 grid grid-cols-[auto,1fr] gap-4" onClick={logout}>
               <div className="flex items-center">
                  <LogoutIcon className="text-gray-500" /> 
               </div>
               <div className="flex items-center text-gray-600 font-bold" >
                  Logout
               </div>
            </div>
         </div>
      </div>
   }
}


const mapStateToProps = state => ({ roles: state.user?.roles || [] });
const Sidebar = connect(mapStateToProps)(_Sidebar);

export default Sidebar;